import React, {PureComponent} from "react"

import {ShareOptionValues} from "@irati/reward/enums"
import {CompanyValue, User} from "@irati/types"
import {CompanyValuesSelect} from "@irati-web/fields/companyValues"
import {Message as MessageField, Share} from "@irati-web/fields/reward"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import {isShareableWithTeams} from "@irati/reward/utils/isShareableWithTeams"
import getSharingOptions from "@irati/reward/constants/share"
import OccasionsSelect from "@irati-web/fields/occasions/OccasionsSelect"
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet"

import {MessageDetails} from "../containers/CreateReward"
import {InputWrapper} from "./styled"

interface Props extends InjectIntl {
  selectedOccasion?: string
  setOccasion: (selectedOccasion: string) => void
  recipients: User[]
  messageDetails: MessageDetails
  setMessageDetails: (messageDetails: any) => void
  isCredit?: boolean
}

interface State {
  clickEventTracked: boolean
  shareEventTracked: boolean
}

class Message extends PureComponent<Props, State> {
  state: State = {
    clickEventTracked: false,
    shareEventTracked: false
  }

  handleMessageChange = (value: string) => {
    const {messageDetails, setMessageDetails} = {...this.props}
    setMessageDetails({...messageDetails, message: value})
  }

  handleShareWithChange = (value: ShareOptionValues) => {
    const {messageDetails, setMessageDetails, isCredit} = {...this.props}
    setMessageDetails({...messageDetails, sharingPreferences: value})
    if (isCredit) {
      rewardWalletTracking.selectPermission()
    }
  }

  handleCompanyValuesChange = (item: any, property: string, values: CompanyValue[]) => {
    const {messageDetails, setMessageDetails, isCredit} = {...this.props}
    if (isCredit && values.length > messageDetails.companyValues.length) {
      rewardWalletTracking.selectCompanyValue()
    }
    setMessageDetails({...messageDetails, companyValues: values})
  }

  getOptions() {
    const {intl, recipients} = this.props
    const user = authentication.user()
    const canShareWithEveryone = !!authentication.apps("recognition.recognition.everyone")
    const canBeSharedWithTeams = isShareableWithTeams(user, recipients)
    return getSharingOptions(intl, canShareWithEveryone, canBeSharedWithTeams)
  }

  handleCompanyValuesSelectClick = () => {
    if (this.props.isCredit && !this.state.clickEventTracked) {
      rewardWalletTracking.clickCompanyValueDropdown()
      this.setState({clickEventTracked: true})
    }
  }

  handleSharePermissionsClick = () => {
    if (this.props.isCredit && !this.state.shareEventTracked) {
      rewardWalletTracking.clickSharePermissions()
      this.setState({shareEventTracked: true})
    }
  }

  render() {
    const {formatMessage, messageDetails, selectedOccasion, setOccasion} = this.props
    const {message, companyValues, sharingPreferences} = messageDetails

    return (
      <>
        <InputWrapper>
          <MessageField
            label={formatMessage({id: "reward.message.field.label"})}
            message={message}
            onChange={this.handleMessageChange}
            placeholder={formatMessage({id: "reward.message.field.placeholder"})}
          />
        </InputWrapper>
        <InputWrapper>
          <OccasionsSelect selectedOption={selectedOccasion} onChange={setOccasion} />
        </InputWrapper>
        <InputWrapper onClick={this.handleCompanyValuesSelectClick}>
          <CompanyValuesSelect item={messageDetails} onChange={this.handleCompanyValuesChange} selectedCompanyValues={companyValues} />
        </InputWrapper>
        <InputWrapper onClick={this.handleSharePermissionsClick}>
          <Share onChange={this.handleShareWithChange} options={this.getOptions()} shareWith={sharingPreferences} />
        </InputWrapper>
      </>
    )
  }
}

export default injectIntl(Message)
